import { render, staticRenderFns } from "./SecaoAlimentarNutricional.vue?vue&type=template&id=502a1348&scoped=true"
import script from "./SecaoAlimentarNutricional.vue?vue&type=script&lang=js"
export * from "./SecaoAlimentarNutricional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502a1348",
  null
  
)

export default component.exports